import React from "react";

export default function UnreadMessagesBanner({ count, onDismiss }) {
  if (!count) return null;
  return (
    <div className="imc-unread-tip" onClick={onDismiss}>
      <img className="imc-unread-arrow" src="resources/251009/down.png" alt="" />
      <span className="imc-unread-text">有新消息</span>
    </div>
  );
}
